/**
 * KINGZ EU — Reviews runtime, consent-gated (2026-10-29)
 * Replaces assets/kingz-lazy-judgeme.js (which injected a stale judgeme-793 loader) and the
 * Judge.me Core app embed (disabled on this theme). File name deliberately has no "judgeme"
 * keyword so the Pandectes blocker rule never blocks this consent listener itself.
 *
 * Loads the CURRENT Judge.me runtime (judgeme-835 loader + CSS) ONLY when Functionality /
 * Preferences consent is given:
 *   - Shopify.customerPrivacy.preferencesProcessingAllowed() === true, or
 *   - the Pandectes consent cookie (_pandectes_gdpr) allows Functionality (preferences bit 1 clear)
 *   and never when Pandectes records a denial of Functionality.
 * Re-checks on Shopify "visitorConsentCollected", Pandectes events and a light cookie poll, so it
 * loads straight after "Accept all" without a reload.
 */
(function () {
  'use strict';
  var cfg = document.getElementById('kz-reviews-config');
  var BASE = (cfg && cfg.getAttribute('data-base')) ||
    'https://cdn.shopify.com/extensions/01a187e4-859e-754f-8799-894a6663f92b/judgeme-835/assets/';
  var loaded = false;

  function pandectes() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_pandectes_gdpr=([^;]+)/);
      if (!m) return null;
      var c = JSON.parse(atob(decodeURIComponent(m[1])));
      if (!c || typeof c.preferences !== 'number') return null;
      return (c.preferences & 1) === 0;           // true = Functionality allowed
    } catch (e) { return null; }
  }
  function shopifyAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.preferencesProcessingAllowed === 'function') return !!cp.preferencesProcessingAllowed();
    } catch (e) {}
    return null;
  }
  function allowed() {
    var p = pandectes();
    if (p === false) return false;                // explicit denial wins
    if (p === true) return true;
    return shopifyAllowed() === true;
  }

  function bootstrap() {
    var e = document, jdgm = window.jdgm = window.jdgm || {};
    jdgm.CDN_HOST = 'https://cdnwidget.judge.me/';
    jdgm.CDN_HOST_ALT = 'https://cdn2.judge.me/cdn/widget_frontend/';
    jdgm.API_HOST = 'https://api.judge.me/';
    jdgm.CDN_BASE_URL = BASE;
    jdgm.CDN_API_HOST = 'https://cdn.judge.me/';
    jdgm.docReady = function (d) { ('loading' !== e.readyState) ? setTimeout(d, 0) : e.addEventListener('DOMContentLoaded', d); };
    jdgm.loadCSS = function (d, t, o, a) {
      if (!o && jdgm.loadCSS.requestedUrls.indexOf(d) >= 0) return;
      jdgm.loadCSS.requestedUrls.push(d);
      a = e.createElement('link'); a.rel = 'stylesheet'; a.className = 'jdgm-stylesheet'; a.media = 'nope!'; a.href = d;
      a.onload = function () { this.media = 'all'; if (t) setTimeout(t); };
      e.body.appendChild(a);
    };
    jdgm.loadCSS.requestedUrls = jdgm.loadCSS.requestedUrls || [];
    jdgm.loadJS = function (u, d) {
      var t = new XMLHttpRequest();
      t.onreadystatechange = function () { if (4 === t.readyState && t.status >= 200 && t.status < 300) { Function(t.response)(); if (d) d(t.response); } };
      t.open('GET', u);
      t.onerror = function () { if (u.indexOf(jdgm.CDN_HOST) === 0 && jdgm.CDN_HOST_ALT !== jdgm.CDN_HOST) jdgm.loadJS(u.replace(jdgm.CDN_HOST, jdgm.CDN_HOST_ALT), d); };
      t.send();
    };
    var s = window.jdgmSettings || {};
    jdgm.docReady(function () {
      if (window.jdgmLoadCSS || e.querySelectorAll('.jdgm-widget, .jdgm-all-reviews-page').length > 0) {
        if (s.widget_load_with_code_splitting) {
          jdgm.loadCSS(BASE + (parseFloat(s.widget_version) >= 3 ? 'widget_v3_base.css' : 'widget_base.css'));
        } else {
          jdgm.loadCSS(BASE + 'shopify_v2.css');
        }
      }
    });
  }

  function load() {
    if (loaded || !allowed()) return;
    loaded = true;
    document.documentElement.classList.add('kz-reviews-ok');
    try { bootstrap(); } catch (e) {}
    try { window.jdgm._loaderExecuted = false; window.jdgm._kzGated = false; } catch (e) {}
    var sc = document.createElement('script');
    sc.src = BASE + 'loader.js';
    sc.defer = true;
    (document.head || document.documentElement).appendChild(sc);
  }

  function check() { if (!loaded) load(); }

  // Make sure the Customer Privacy API is available (no third-party request; Shopify-hosted).
  try {
    if (!(window.Shopify && window.Shopify.customerPrivacy) && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { check(); });
    }
  } catch (e) {}

  ['visitorConsentCollected', 'PandectesConsentUpdate', 'PandectesEvent_OnConsent', 'pandectes:consent'].forEach(function (ev) {
    try { document.addEventListener(ev, function () { setTimeout(check, 50); }); } catch (e) {}
    try { window.addEventListener(ev, function () { setTimeout(check, 50); }); } catch (e) {}
  });

  // Light poll: catches the banner's cookie write right after "Accept all" (stops once loaded / after 10 min).
  var n = 0, iv = setInterval(function () { n++; if (loaded || n > 600) { clearInterval(iv); return; } check(); }, 1000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
